import { faker } from '@faker-js/faker';

import {
  ENOPCaseStatus,
  ENOPDonorType,
  Hospital,
  NewCase,
  Organ,
} from '#entities';
import { ENOPOrganType } from '#shared';

export const generateOrgan = (organType?: ENOPOrganType): Organ => ({
  id: faker.string.uuid(),
  name:
    organType ||
    faker.helpers.arrayElement([
      ENOPOrganType.Heart,
      ENOPOrganType.Liver,
      ENOPOrganType.Lungs,
    ]),
  startPoint: faker.number.int({ min: 0, max: 100 }),
});

export const generateHospital = (): Hospital => ({
  location: faker.location.city(),
  address: `${faker.location.streetAddress()}, ${faker.location.city()}, ${faker.location.state({ abbreviated: true })}`,
  state: faker.location.state({ abbreviated: true }),
  lonLat: [
    faker.location.longitude({ min: -125, max: -66 }), // US longitude range
    faker.location.latitude({ min: 25, max: 49 }), // US latitude range
  ],
  timezone: faker.location.timeZone(),
  code: faker.string.alpha(4).toUpperCase(),
});

export const generateNewCase = (overrides?: Partial<NewCase>): NewCase => {
  const organTypes: ENOPOrganType[] = [
    ENOPOrganType.Heart,
    ENOPOrganType.Liver,
    ENOPOrganType.Lungs,
  ];
  const donorTypes: ENOPDonorType[] = [ENOPDonorType.DCD, ENOPDonorType.DBD];
  const unosDonorId = `${faker.string.alpha(4).toUpperCase()}${faker.string.numeric(3)}`;

  return {
    id: faker.string.uuid(),
    unosDonorId,
    label: `${unosDonorId}-${faker.helpers.arrayElement(['HT', 'LI', 'LU', 'KI'])}`,
    donorType: faker.helpers.arrayElement(donorTypes),
    oscStatus: faker.helpers.arrayElement([
      ENOPCaseStatus.ClinicalScreening,
      ENOPCaseStatus.Accepted,
      ENOPCaseStatus.PendingLogistics,
    ]),
    donorORDateTimeUtc: faker.datatype.boolean()
      ? faker.date.future().toISOString()
      : null,
    donorORTimeString: faker.date.future().toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit',
      timeZoneName: 'short',
    }),
    caseTimerEndString: faker.datatype.boolean()
      ? `+${faker.string.numeric(2)}:${faker.string.numeric(2)}`
      : null,
    organ: generateOrgan(faker.helpers.arrayElement(organTypes)),
    donorHospital: generateHospital(),
    recipientHospital: generateHospital(),
    transplantCenterCode: faker.string.alpha(4).toUpperCase(),
    showOnMap: true,
    trialProgram: null,
    serviceRegionId: undefined,
    ...overrides,
  };
};
